import { SortTypeEnum } from "@repo/helpers";
import { IncidentStatus } from "@repo/models";
import { Column, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";

import { useRepIncidentQueries } from "../../../../api/repIncidentApi";
import { Props } from "./types";

export default function IncidentHistoryGrid(props: Props) {
	const { useHistoriesQuery } = useRepIncidentQueries();
	const incidentId = props.component.propertyValue;

	const { data, loaded, clearQuery } = useHistoriesQuery(incidentId);

	return <GridPreLoaded {...props} values={data?.data ?? []} loading={!loaded} getData={clearQuery} />;
}

IncidentHistoryGrid.defaultProps = {
	columns: [
		new OriginalTimezoneDateColumn("Timestamp", "timestamp").dateOnly().withSortBy(SortTypeEnum.descending),
		new Column("Message", "message"),
		new Column("User Name", "userName"),
		new Column("Status", "status").withFormat((i) => IncidentStatus[i]),
	],
	title: null,
	id: "incidentHistGrid",
	values: [],
	keyProperty: "id",
	pageSize: 5,
} as Props;
